<template>
    <div class="horizontalLayoutItem">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "horizontalLayoutItem"
}
</script>

<style lang="scss" scoped>
.horizontalLayoutItem {
    float: left;
}
</style>
